import { getUserInfo } from './getters/get_user_info'
import { getTickets } from './getters/get_tickets'
import { getOpenId } from './getters/get_open_id'
import { getCityId } from './getters/get_city_id'
import { getAreaId } from './getters/get_area_id'
import { getCompanyId } from './getters/get_company_id'
import { getPassportId } from './getters/get_passport_id'
import { getBCLocation } from './getters/get_bc_location'
import { getPhone } from './getters/get_phone'
import { eventbus } from '@/utils/eventbus'
import { EventNames } from '../events'
import { getCmsPreviewKey } from './getters/get_cms_preview_key'
import { getUserCode } from './getters/get_user_code'
import { getCompanyToken } from './getters/get_company_token'

export const userInfo = getUserInfo()
export let tickets = getTickets(userInfo)
export let openId = getOpenId()
export let cityId = getCityId(userInfo)
export let areaId = getAreaId(userInfo)
export let companyId = getCompanyId(userInfo)
export const passportId = getPassportId(userInfo)
export const cmsPreviewKey = getCmsPreviewKey()
export let bcLocation = getBCLocation(userInfo)
export const userCode = getUserCode()
export let phone = getPhone(userInfo)
export let deviceToken
export let companyToken = getCompanyToken(userInfo)
export function updateBCLocation() {
  return getBCLocation(userInfo)
}

eventbus.addEventListener(EventNames.miniProgramDetected, () => {
  // Android 小程序 webview 这里同步更新不了，暂且 setTimeout 大法异步一下
  setTimeout(() => {
    tickets = getTickets(userInfo)
    openId = getOpenId()
    bcLocation = getBCLocation(userInfo)
    cityId = getCityId(userInfo)
    areaId = getAreaId(userInfo)
    companyId = getCompanyId(userInfo)
    phone = getPhone(userInfo)
    companyToken = getCompanyToken(userInfo)
  }, 0)
})

eventbus.addEventListener(EventNames.getDeviceToken, appDeviceToken => {
  deviceToken = appDeviceToken
})
